'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StyledTable = require('./StyledTable');

var _StyledTable2 = _interopRequireDefault(_StyledTable);

var _OverflowContainer = require('./OverflowContainer');

var _OverflowContainer2 = _interopRequireDefault(_OverflowContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Table = function Table(_ref) {
  var children = _ref.children,
      striped = _ref.striped,
      vertStriped = _ref.vertStriped,
      alignBody = _ref.alignBody,
      alignHeader = _ref.alignHeader,
      compact = _ref.compact,
      overflow = _ref.overflow,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['children', 'striped', 'vertStriped', 'alignBody', 'alignHeader', 'compact', 'overflow']);
  return _react2.default.createElement(
    'div',
    null,
    overflow ? _react2.default.createElement(
      _OverflowContainer2.default,
      null,
      _react2.default.createElement(
        _StyledTable2.default,
        (0, _extends3.default)({
          compact: compact,
          striped: striped,
          alignBody: alignBody,
          alignHeader: alignHeader,
          vertStriped: vertStriped
        }, rest),
        children
      )
    ) : _react2.default.createElement(
      _StyledTable2.default,
      (0, _extends3.default)({
        compact: compact,
        striped: striped,
        alignBody: alignBody,
        alignHeader: alignHeader,
        vertStriped: vertStriped
      }, rest),
      children
    )
  );
};

Table.propTypes = {
  alignBody: _propTypes2.default.string,
  alignHeader: _propTypes2.default.string,
  children: _propTypes2.default.node,
  compact: _propTypes2.default.bool,
  striped: _propTypes2.default.bool,
  overflow: _propTypes2.default.bool,
  vertStriped: _propTypes2.default.bool
};

Table.defaultProps = {
  alignBody: '',
  alignHeader: '',
  children: null,
  compact: false,
  striped: false,
  overflow: true,
  vertStriped: false
};

Table.huiName = 'Table';
Table.displayName = 'Table';

exports.default = Table;
//# sourceMappingURL=Table.js.map


//////////////////
// WEBPACK FOOTER
// ../table/lib/Table.js
// module id = 656
// module chunks = 0